// hooks.client.ts — SvelteKit browser hooks. Boot the PostHog SDK and forward
// render/navigation errors to error tracking.

import type { HandleClientError } from '@sveltejs/kit';
import { initPostHog, captureException } from '$lib/posthog';

// Fire and forget — init is idempotent + no-ops when PUBLIC_POSTHOG_KEY is empty.
void initPostHog();

// SvelteKit routes every uncaught client render / navigation / $effect / load
// error through here. It catches them BEFORE window.onerror, so PostHog's
// implicit exception autocapture never sees them — without this captureException
// the most common client error class would only ever reach the console. Keep the
// console.error too (local dev + container logs).
export const handleError: HandleClientError = ({ error, event, status, message }) => {
	console.error('[hooks.client] handleError', error);
	captureException(error, {
		source: 'sveltekit.handleError',
		status,
		route: event?.route?.id ?? null,
		message,
	});
	return { message: 'An unexpected error occurred.' };
};
